import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'is_the_facs_apprenticeship_training_internship_program_in_line'

export const dataPointDefinition = {
  retracedId: 'is_the_facs_apprenticeship_training_internship_program_in_line',
  name: "Is the facility's apprenticeship / training / internship program in line with all legal requirements?",
  description:
    'The intent of this question is to cover any applicable legal requirements to determine contractual, training and related requirements regarding apprentices, trainees, interns. Probationary periods / trial periods are covered separately, and should not be recorded here.\r\r\nIf apprentices, trainees, interns are below minimum age requirements, record under the question: "Are any workers under the legal minimum age for employment?".\r\r\nIf apprentices, trainees, etc. are working/training during overtime, at night, or for more hours than allowed by law, record under the appropriate item for the question, "Which of the following work is performed by workers under age 18 ".\r\r\n\r\r\nConsult applicable legal requirements before answering this question. \r\r\n\r\r\nIf there are no applicable legal requirements, answer No applicable legal requirements. \r\r\n\r\r\nFor example, if the time period/ length of employment/contract for an apprentice is not in line with legal requirements, Answer No.',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no-nalr',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
    },
    {
      name: 'No applicable legal requirements',
      key: 'NO_APPLICABLE_LEGAL_REQS',
      slcpIndex: 3,
      slcpOptionName: 'yes-no-nalr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NO_APPLICABLE_LEGAL_REQS'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'cl-5--11',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 4840,
  sectionId: '2.2.4.1',
  impactArea: 'Recruitment, Hiring & Termination Practices',
  impactAreaId: 'RECRUITMENT_HIRING_AND_TERMINATION_PRACTICES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
